import { render, staticRenderFns } from "./AsideLayout.vue?vue&type=template&id=4ca11c3e&scoped=true&lang=pug&"
import script from "./AsideLayout.vue?vue&type=script&lang=js&"
export * from "./AsideLayout.vue?vue&type=script&lang=js&"
import style0 from "./AsideLayout.vue?vue&type=style&index=0&id=4ca11c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca11c3e",
  null
  
)

export default component.exports